import ROUTE_URLS from "@/constants/route-urls";

export interface CreateSubcategoryUrlParams {
  parentCode: string;
  parentDescription: string;
  language: string;
}

export const buildCreateSubcategoryUrl = (params: CreateSubcategoryUrlParams): string => {
  const { parentCode, parentDescription, language } = params;

  const baseUrl = ROUTE_URLS.createProductCategory(language as "PT-BR");

  const queryParams = new URLSearchParams();
  queryParams.set("parentCode", parentCode);
  queryParams.set("parentDescription", parentDescription);

  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
